import { render, staticRenderFns } from "./SkeletonDeadlines.vue?vue&type=template&id=04a6b9e8&scoped=true&"
import script from "./SkeletonDeadlines.vue?vue&type=script&lang=js&"
export * from "./SkeletonDeadlines.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonDeadlines.vue?vue&type=style&index=0&id=04a6b9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6b9e8",
  null
  
)

component.options.__file = "SkeletonDeadlines.vue"
export default component.exports